<template>
  <div>
  <div class="pdf-preview" v-if="pdfFile">
      <button @click.self="closePreview()">
        &times;
    </button>

    <iframe
      :src="pdfFile"
      width="100%"
      height="100%"
    />
    </div>
    <div v-show="false">
    <div ref="testHtml">
    <section slot="pdf-content" class="mx-5 my-4">

      <div v-if="response.items.container.length === 0">
        <div class="pdf-item mb-3 d-flex text-xl justify-content-center font-weight-bold">
        <div>
          MANIFEST
        </div>
      </div>
      <section class="pdf-item mb-3 d-flex justify-content-between">
        <div class="text-xs">
          <div>
            {{ response.exporterFirstName.toUpperCase() }}
            {{ response.exporterLastName.toUpperCase() }}
            <br>
            {{ response.exporterAddress.toUpperCase() }}
            <br>
            {{ response.exporterCity.toUpperCase() }},
            {{ response.exporterState.toUpperCase() }}
            {{ response.exporterZipCode }}
            <br>
            Tel: {{ response.exporterPhone }}</div>
        </div>
        <div class="text-xs">
          <div>
            {{ response.importerFirstName.toUpperCase() }}
            {{ response.importerLastName.toUpperCase() }}
            <br>
            {{ response.importerAddress.toUpperCase() }}
            <br>
            {{ response.importerCity.toUpperCase() }},
            {{ response.importerState.toUpperCase() }}
            {{ response.importerZipCode }}
            <br>
            Tel: {{ response.importerPhone }}
          </div>
        </div>
      </section>
      <section class="pdf-item mb-3 d-flex justify-content-between">
        <div class="text-sm">
          <div>
            CONTAINER:
            <br>
           SHIP/VOYAGE: {{ response.vessel.toUpperCase() }} {{ response.voyage.toUpperCase() }}
           <br>
            MANIFEST: {{ response.billOfLading }}
        </div>
      </div>
        <div class="text-sm">
          <div>
            DATE SHIPPED: {{ response.shippedDate }}
            <br>
           DESTINATION: {{ response.destination.toUpperCase() }}
           <br>
          ETA DATE: {{ response.arrivalDate }}
          </div>
        </div>
      </section>
      <section class="pdf-item mb-3 text-left">
        <table class="table text-xs w-100">
          <tr class="text-xs text-gray-700">
            <th>B/L#:</th>
            <th>Sender:</th>
            <th>Consignee:</th>
            <th>Contents:</th>
            <th>Vol(CF) Weight(Lb)</th>
          </tr>
          <tr>
            <td></td>
            <td>
              <div></div>
              <div></div>
              <div>
              </div>
              <div></div>
            </td>
            <td>
              <div></div>
              <div></div>
              <div>
              </div>
              <div></div>
            </td>
            <td>
              <div>
              </div>
            </td>
            <td>
              <div></div>
            </td>
          </tr>
        </table>
        <div class="font-weight-bold d-flex justify-content-between border-top">
          <span>Total</span>
          <span>
           0 PCS  0 LBS
          </span>
        </div>
      </section>
      </div>
      <div v-for="(container,index) in response.items.container"
                  :key="container.id">
      <div v-for="page in totalPages(container)" :key="page" class="mx-5 my-4">
      <div class="pdf-item mb-3 d-flex text-xl justify-content-center font-weight-bold">
        <div>
          MANIFEST
        </div>
      </div>
      <section class="pdf-item mb-3 d-flex justify-content-between">
        <div class="text-xs">
          <div>
            {{ response.exporterFirstName.toUpperCase() }}
            {{ response.exporterLastName.toUpperCase() }}
            <br>
            {{ response.exporterAddress.toUpperCase() }}
            <br>
            {{ response.exporterCity.toUpperCase() }},
            {{ response.exporterState.toUpperCase() }}
            {{ response.exporterZipCode }}
            <br>
            Tel: {{ response.exporterPhone }}</div>
        </div>
        <div class="text-xs">
          <div>
            {{ response.importerFirstName.toUpperCase() }}
            {{ response.importerLastName.toUpperCase() }}
            <br>
            {{ response.importerAddress.toUpperCase() }}
            <br>
            {{ response.importerCity.toUpperCase() }},
            {{ response.importerState.toUpperCase() }}
            {{ response.importerZipCode }}
            <br>
            Tel: {{ response.importerPhone }}
          </div>
        </div>
      </section>
      <section class="pdf-item mb-3 d-flex justify-content-between">
        <div class="text-sm">
          <div>
            CONTAINER: {{container.name}}
            <br>
           SHIP/VOYAGE: {{ response.vessel.toUpperCase() }} {{ response.voyage.toUpperCase() }}
           <br>
            MANIFEST: {{ response.billOfLading }}
        </div>
      </div>
        <div class="text-sm">
          <div>
            DATE SHIPPED: {{ response.shippedDate }}
            <br>
           DESTINATION: {{ response.destination.toUpperCase() }}
           <br>
          ETA DATE: {{ response.arrivalDate }}
          </div>
        </div>
      </section>
      <section class="pdf-item mb-3 text-left">
        <table class="table text-xs w-100">
          <tr class="text-xs text-gray-700">
            <th>B/L#:</th>
            <th>Sender:</th>
            <th>Consignee:</th>
            <th>Contents:</th>
            <th>Vol(CF) Weight(Lb)</th>
          </tr>
          <tr v-for="(item) in paginatedData(container,page-1)"
                  :key="item.id">
            <td>{{item.billOfLading}}</td>
            <td>
              <div>{{item.shipper}}</div>
              <div>{{item.shipperInfo.address}}</div>
              <div>{{item.shipperInfo.city}},
                {{item.shipperInfo.state}} {{item.shipperInfo.zipCode}}
              </div>
              <div>{{item.shipperInfo.phone}}</div>
            </td>
            <td>
              <div>{{item.consignee}}</div>
              <div>{{item.consigneeInfo.address}}</div>
              <div>{{item.consigneeInfo.city}},
                {{item.consigneeInfo.state}} {{item.consigneeInfo.zipCode}}
              </div>
              <div>{{item.consigneeInfo.phone}}</div>
            </td>
            <td>
              <div v-for="(shipment) in item.items"
                  :key="shipment.id" >
                {{shipment.qty}}
                {{shipment.packageType}}
                <br>
                {{shipment.length}} x {{shipment.width}} x {{shipment.height}}
                <br>
                <span v-for="(seal) in shipment.seal" :key="seal.id">
                    <span v-if="seal.value">
                      Seal# {{seal.value}}
                    </span>
                  </span>
              </div>
            </td>
            <td>
              <div>{{itemMeasurement(item, 'ft')}} CF {{itemWeight(item, 'lb')}} LBS</div>
              <div v-if="item.oustandingBalance > 0">
                Outstanding Balance: ${{item.oustandingBalance}}
              </div>
            </td>
          </tr>
        </table>
        <div class="font-weight-bold d-flex justify-content-between border-top">
          <span>Total</span>
          <span>
            {{containerQty(container.item)}} PCS  {{containerWeight(container.item, 'lb')}} LBS
          </span>
        </div>
      </section>
      <div v-if="page < totalPages" class="html2pdf__page-break" />
    </div>
    <div v-if="index < response.items.container.length-1" class="html2pdf__page-break" />
    </div>
    </section>
  </div>
</div>
  </div>
  <!-- </VueHtml2pdf> -->
</template>

<script>
// import VueHtml2pdf from 'vue-html2pdf';
import html2pdf from 'html2pdf.js';

export default {
  name: 'PrintManifest',
  props: [
    'name',
    'response',
    'currentUser',
  ],
  data() {
    return {
      pdfFile: null,
      items: [],
      size: 5,
    };
  },
  computed: {
  },
  // components: {
  //   VueHtml2pdf,
  // },
  methods: {
    closePreview() {
      this.pdfFile = null;
    },
    generatePdf() {
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      // const doc = new jsPDF('p', 'pt', 'A4');
      // const margins = {
      //   top: 80,
      //   bottom: 60,
      //   left: 40,
      //   width: 522,
      // };

      // doc.html(this.$refs.testHtml, { left: margins.left, width: margins.width }).then(() => {
      //   doc.output('dataurlnewwindow');
      // });
      const opt = {
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          dpi: 300,
          scale: 4,
        },
      };

      html2pdf().from(this.$refs.testHtml).set(opt).output('bloburl')
        .then((ref) => {
          this.pdfFile = ref;
        });
    },
    itemWeight(item, type) {
      if (type === 'lb') {
        return parseFloat(item.weight).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(item.weight / 2.2046).toFixed(3).replace(/\.000$/, '');
    },
    itemMeasurement(item, type) {
      if (type === 'ft') {
        return parseFloat(item.volume / 1728).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(item.volume / 61023.7441).toFixed(3).replace(/\.000$/, '');
    },
    containerWeight(item, type) {
      const weight = item.reduce(
        (accumulator, currentValue) => accumulator + currentValue.weight,
        0,
      );
      if (type === 'lb') {
        return parseFloat(weight).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(weight / 2.2046).toFixed(3).replace(/\.000$/, '');
    },
    containerMeasurement(item, type) {
      const volume = item.reduce(
        (accumulator, currentValue) => accumulator + currentValue.volume,
        0,
      );
      if (type === 'ft') {
        return parseFloat(volume / 1728).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(volume / 61023.7441).toFixed(3).replace(/\.000$/, '');
    },
    containerQty(item) {
      return item.reduce(
        (accumulator, currentValue) => accumulator + currentValue.qty,
        0,
      );
    },
    totalPages(container) {
      return Math.ceil(container.item.length / this.size);
    },
    paginatedData(container, page) {
      const start = page * this.size;
      const end = start + this.size;
      const paginated = container.item.slice(start, end);
      // while (paginated.length < this.size) {
      //   paginated.push({
      //     airportCode: '',
      //     billOfLading: '',
      //     consignee: '',
      //     consigneeInfo: {
      //       address: '',
      //       aesITN: '',
      //       city: '',
      //       Country: '',
      //       email: '',
      //       firstName: '',
      //       lastName: '',
      //       phone: '',
      //       state: '',
      //       zipCode: '',
      //     },
      //     shipper: '',
      //     shipperInfo: {
      //       address: '',
      //       aesITN: '',
      //       city: '',
      //       Country: '',
      //       email: '',
      //       firstName: '',
      //       lastName: '',
      //       phone: '',
      //       state: '',
      //       zipCode: '',
      //     },
      //     outstandingBalance: '',
      //     qty: '',
      //     status: '',
      //     volume: '',
      //     weight: '',
      //     items: [],
      //   });
      // }
      return paginated;
    },
  },
  filters: {
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
};
</script>

<style lang="scss" scoped>

.table {
  margin-bottom: -0.8px;
}

.table-bordered td, .table-bordered th {
  border: 1px solid #343434;
}

.heading {
  border-bottom: 1px solid #343434;
}

.bordered {
  border: 1px solid #343434;
}

.borderedLeft {
  border-left: 1px solid #343434
}

.smalltext {
  font-size: 0.55rem;
  line-height: 1rem;
}

.pdf-preview {
  position: fixed;
  width: 65%;
  min-width: 600px;
  height: 80vh;
  top: 100px;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0px 0px 10px #00000048;

  button {
    position: absolute;
    top: -20px;
    left: -15px;
    width: 35px;
    height: 35px;
    background: #555;
    border: 0;
    box-shadow: 0px 0px 10px #00000048;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
  }

  iframe {
    border: 0;
  }

}

</style>
